import { render, staticRenderFns } from "./SentimentTooltip.vue?vue&type=template&id=5d061268"
import script from "./SentimentTooltip.vue?vue&type=script&lang=js"
export * from "./SentimentTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports